import React from "react";
import { Box, Container } from "@mui/material";

const Footer = () => {
  return (
    <Container sx={{ height: "auto !important" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <div style={{ marginTop: "20px" }}>
          <p>
            Please fill our{" "}
            <a
              href="https://deloitteglobal.service-now.com/sp?id=sc_cat_item&sys_id=4a417b4f1b17855cbcae55b0604bcb1c"
              target="_blank"
              style={{ color: "rgb(0 151 215)", fontWeight: "500" }}
              rel="noreferrer"
            >
              Support Request
            </a>
            &nbsp; Form if you face any issues.
          </p>
        </div>
      </Box>
    </Container>
  );
};

export default Footer;
